import {TODAY_TARABI} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case TODAY_TARABI:
            return action.payload;
        default:
            return state;
    }
};